import { Gamepad2, BookOpen, Pizza, Smile, Palette, Music } from "lucide-react";

const services = [
  {
    icon: Gamepad2,
    title: "Fun Games",
    desc: "Board games, tag, hide-and-seek and made-up adventures.",
    bg: "bg-[#FF6B9E]",
    pop: "shadow-pop",
  },
  {
    icon: BookOpen,
    title: "Story Time",
    desc: "Picture books with all the voices and giggles included.",
    bg: "bg-[#4DB8FF]",
    pop: "shadow-pop",
  },
  {
    icon: Palette,
    title: "Arts & Crafts",
    desc: "Drawing, coloring, sticker chaos and friendship bracelets.",
    bg: "bg-[#38E5B6]",
    pop: "shadow-pop",
  },
  {
    icon: Pizza,
    title: "Snack Helper",
    desc: "Simple snacks (with permission), tidy hands, happy tummies.",
    bg: "bg-[#FFD166]",
    pop: "shadow-pop",
  },
  {
    icon: Music,
    title: "Sing & Dance",
    desc: "Mini dance parties and silly sing-alongs guaranteed.",
    bg: "bg-[#FF8E72]",
    pop: "shadow-pop",
  },
  {
    icon: Smile,
    title: "Just Hangs",
    desc: "Quiet play, puzzles and kindness — calm vibes too.",
    bg: "bg-[#FFEBF2]",
    pop: "shadow-pop",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 px-4"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="font-hand text-3xl text-[#38E5B6]">~ what we do ~</span>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl text-gray-900 mt-2">
            Pure <span className="text-[#FF6B9E]">FUN</span>, with a side of being responsible 😉
          </h2>
        </div>

        {/* Kid Kit highlight */}
        <div
          data-testid="services-kid-kit"
          className="relative max-w-4xl mx-auto mb-12 bg-[#4DB8FF] border-4 border-gray-900 rounded-3xl p-6 sm:p-8 shadow-pop rotate-1"
        >
          <div className="absolute -top-5 -right-5 w-20 h-20 bg-[#FF6B9E] border-4 border-gray-900 rounded-full flex items-center justify-center font-display text-sm text-white -rotate-12 shadow-pop-sm">
            NEW!
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left">
            <div className="text-6xl sm:text-7xl">🎒</div>
            <div>
              <h3 className="font-display text-3xl sm:text-4xl text-white mb-2">
                We bring Kid Kits!
              </h3>
              <p className="text-base sm:text-lg text-white font-semibold leading-relaxed">
                Every visit comes with our signature Kid Kit — packed with games,
                coloring pages, stickers, craft supplies and fun surprises to keep
                little ones busy and smiling!
              </p>
            </div>
          </div>
        </div>

        <div
          data-testid="services-grid"
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${i}`}
                className={`group bg-white border-4 border-gray-900 rounded-3xl p-7 ${s.pop} hover:-translate-y-2 hover:rotate-1 transition-all duration-300`}
              >
                <div
                  className={`w-16 h-16 ${s.bg} border-4 border-gray-900 rounded-2xl flex items-center justify-center mb-5 group-hover:rotate-[-8deg] transition-transform`}
                >
                  <Icon size={32} className="text-gray-900" strokeWidth={2.5} />
                </div>
                <h3 className="font-display text-2xl text-gray-900 mb-2">{s.title}</h3>
                <p className="text-base text-gray-700 font-semibold leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>

        {/* Note strip */}
        <div
          data-testid="services-note"
          className="mt-12 max-w-3xl mx-auto bg-[#FFD166] border-4 border-gray-900 rounded-3xl p-6 shadow-pop -rotate-1 text-center"
        >
          <p className="font-hand text-2xl text-gray-900 leading-tight">
            ✨ Two sitters always come together — and our 17-year-old manager is nearby, so everyone stays safe and happy! ✨
          </p>
        </div>
      </div>
    </section>
  );
}
